import { Text } from "@fluentui/react/lib/Text";

import { WithTranslator } from "Components/Generic/Translator";
import { isNullish } from "Utils/Null";
import { omitNullish, safeUnique } from "Utils/Array";
import { getTranslatedSingularFieldLabel } from "Utils/Field";
import { getItemType } from "Utils/Item";
import { NavigateExternalInlineIcon } from "@fluentui/react-icons-mdl2";
import { IUrlListValueProps } from "./IUrlListValueProps";
import { BigUrlValue } from "./BigUrlValue";
import { SmallUrlValue } from "./SmallUrlValue";
import { useUrlListStyles } from "./UseUrlListStyles";

export const UrlListValue = WithTranslator((props: IUrlListValueProps): JSX.Element => {
  const {
    translator, fieldName, item, placeholder
  } = props;
  const styles = useUrlListStyles();
  const urlList = item[fieldName] as string[];

  if (isNullish(urlList)) {
    return <Text variant="smallPlus">{placeholder}</Text>;
  }

  const safeUrlList = omitNullish(safeUnique(urlList));
  const UrlComponent = urlList.length <= 3 ? BigUrlValue : SmallUrlValue;
  return (
    <>
      <NavigateExternalInlineIcon className={styles.icon} />
      {safeUrlList.map((url, index) => (
        <UrlComponent
          key={url}
          url={url}
          label={getTranslatedSingularFieldLabel(fieldName, getItemType(item), translator)}
          count={index + 1}
        />
      ))}
    </>
  );
});
